export default __webpack_public_path__ + "static/title-fast-5fb9246f0260eee0abdbe172f16c66df.png";